import React from 'react';

export default class Editor extends React.Component {
    static defaultProps = {
        value: ''
    }

    getValue() {
        return this.editor.value;
    }

    render() {
        const { value, onUpdate, ...rest } = this.props;
        return [
            <input
                {...rest}
                key="text"
                tabIndex="0"
                ref={node => this.editor = node}
                type="text"
                maxLength="35"
                minLength="1"
                className='form-control'
                onChange={() => { }}
                onBlur={() => onUpdate(this.getValue())}
            />
        ];
    }
}
